export enum COOKIES_NAMES {
  CART_ID = 'vsf-cart',
  USER = 'vsf-user',
  USER_TOKEN = 'vsf-sap-token'
}

export const ANONYMOUS_USER_ID = 'anonymous';
export const CURRENT_USER_ID = 'current';

export const IMAGE_FORMATS = {
  PRODUCT: 'product'
};

export const AUTH_USER_TOKEN_COOKIE_NAME = 'vsf-sap-token';
export const AUTH_USER_TOKEN_SET_COOKIE_NAME = 'vsf-sap-token-set';
export const USER_COOKIE_NAME = 'user';
export const CART_ID_COOKIE_NAME = 'CART_ID';
export const ANONYMOUS_CONSENTS_LS_ITEM_NAME = 'anonymous-consents';

export const CART_USER = 'cart-user';
